interface ErrorBannerProps {
  message: string
}

/**
 * Canonical API-level error banner. Uses the semantic `error-*` theme tokens
 * so it stays consistent across light and dark modes. For inline field
 * errors prefer the `error` prop on `TextField`, `Textarea`, or `FormField`.
 */
export function ErrorBanner({ message }: ErrorBannerProps) {
  if (!message) return null

  return (
    <div role="alert" className="bg-error-bg border border-error-border text-error-text px-4 py-3 rounded">
      {message}
    </div>
  )
}
